module.exports = __webpack_public_path__ + "static/media/dashboardlogo (2).a6925b9a.png";